<div class="container-fluid">
  <div class="row mt-5" *ngIf="showContent">
    <div class="col-md-12">
      <div class="alert-card">
        <div class="row">
          <div class="col-md-2">
            <img *ngIf="tipoAlerta=='verde'" class="centerImg" src="assets/icons/Botones Politicas Verde.png" height="50px" >
            <img *ngIf="tipoAlerta=='rojo'" class="centerImg" src="assets/icons/Botones Politicas rojo.png" height="50px" >
            <img *ngIf="tipoAlerta=='amarillo'" class="centerImg" src="assets/icons/Boton Amarillo.png" height="50px" >
          </div>
          <div class="col-md-10">
            <div *ngIf="tipoAlerta=='verde'">
              <p>LA PRECALIFICACION <strong>#{{ clienteserviceParam.ofertasComerciales.numeroPrecalificacion }}</strong></p>
              <h4>FUE <strong class="{{tipoAlerta}}">PREAPROBADA</strong></h4>
            </div>
            <div *ngIf="tipoAlerta=='rojo'">
              <p>LA PRECALIFICACION <strong>#{{ clienteserviceParam.ofertasComerciales.numeroPrecalificacion }}</strong></p>
              <h4>FUE <strong class="{{tipoAlerta}}">RECHAZADA</strong></h4>
            </div>
            <div *ngIf="tipoAlerta=='amarillo'&&!clienteserviceParam.rolABFlag">
              <p>LA PRECALIFICACION <strong>#{{ clienteserviceParam.ofertasComerciales.numeroPrecalificacion }}</strong></p>
              <h4>necesita <strong class="{{tipoAlerta}}">seguimiento</strong> comunícate a tu Centro de Procesamiento asignado.</h4>
            </div>
            <div *ngIf="tipoAlerta=='amarillo'&& clienteserviceParam.rolABFlag">
              <p>LA PRECALIFICACION <strong>#{{ clienteserviceParam.ofertasComerciales.numeroPrecalificacion }}</strong></p>
              <h4>necesita <strong class="{{tipoAlerta}}">seguimiento,</strong> acercate a un Centro de Negocio.</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12" *ngIf="clienteserviceParam.flowType === 'DEBTOR'">
      <div class="alert-card">
        <div class="row">
          <div class="col-md-2">
            <img *ngIf="tipoAlerta=='verde'" class="centerImg" src="assets/icons/Botones Politicas Verde.png" height="50px" >
            <img *ngIf="tipoAlerta=='rojo'" class="centerImg" src="assets/icons/Botones Politicas rojo.png" height="50px" >
            <img *ngIf="tipoAlerta=='amarillo'" class="centerImg" src="assets/icons/Boton Amarillo.png" height="50px" >

          </div>
          <div class="col-md-10">
           <div *ngIf="tipoAlerta=='verde'">
             <p>EL CLIENTE</p>
             <h3>{{clienteserviceParam.datosCliente.cliente.nombreCompleto|accentMark: false }}</h3>
             <h4>FUE <strong class="{{tipoAlerta}}">PREAPROBADO</strong></h4>
           </div>
            <div *ngIf="tipoAlerta=='rojo'">
              <p>EL CLIENTE</p>
              <h3>{{clienteserviceParam.datosCliente.cliente.nombreCompleto |accentMark: false }}</h3>
              <h4>FUE <strong class="{{tipoAlerta}}">RECHAZADO</strong></h4>
              <h4 *ngIf="clienteserviceParam.listReglaRechazo.length==0">En este momento el cliente no aplica a una oferta Bienestar.</h4>
            </div>
            <div *ngIf="tipoAlerta=='amarillo'">
              <p>AL CLIENTE</p>
              <h3>{{clienteserviceParam.datosCliente.cliente.nombreCompleto |accentMark: false }}</h3>
              <h4>SE LE DEBE DAR <strong class="{{tipoAlerta}}">SEGUIMIENTO</strong></h4>
              <h4 *ngIf="clienteserviceParam.listReglaRechazo.length==0">En este momento el cliente no aplica a una oferta Bienestar.</h4>
            </div>
            <br>
            <div *ngIf="clienteserviceParam.listReglaRechazo.length > 0 &&!clienteserviceParam.rolABFlag">
              <h1>REGLAS DE RECHAZO  <i (click)="isCollapseDebtor = !isCollapseDebtor"
                class="bi bi-arrow-down rejected-rules-collapse-icon">
              </i>
              </h1>
              <div *ngIf="!isCollapseDebtor">
                <h1 class="rejected-rules mt-4"
                    *ngFor="let regla of clienteserviceParam.listReglaRechazo; let i = index">
                  {{ i + 1 }}. {{ regla.reglaNombre }}
                  <hr *ngIf="clienteserviceParam.listReglaRechazo.length > 1">
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12" *ngIf="clienteserviceParam.flowType === 'CODEBTOR'">
      <div class="alert-card">
        <div class="row">
          <div class="col-md-2">
            <img *ngIf="clienteserviceParam.listReglaRechazo.length === 0" class="centerImg" src="assets/icons/Botones Politicas Verde.png" height="50px" >
            <img *ngIf="clienteserviceParam.listReglaRechazo.length > 1 ||(clienteserviceParam.listReglaRechazo.length == 1 && clienteserviceParam.listReglaRechazo[0].reglaDecision == 'RECHAZAR') " class="centerImg" src="assets/icons/Botones Politicas rojo.png" height="50px" >
            <img *ngIf="clienteserviceParam.listReglaRechazo.length == 1 && clienteserviceParam.listReglaRechazo[0].reglaDecision == 'SIN DECISION'" class="centerImg" src="assets/icons/Boton Amarillo.png" height="50px" >
          </div>
          <div class="col-md-10">
            <div *ngIf="clienteserviceParam.listReglaRechazo.length === 0">
              <p>EL CLIENTE</p>
              <h3>{{clienteserviceParam.datosCliente.cliente.nombreCompleto|accentMark: false }}</h3>
              <h4>FUE <strong class="verde">PREAPROBADO</strong></h4>
            </div>
            <div *ngIf="clienteserviceParam.listReglaRechazo.length > 1 ||(clienteserviceParam.listReglaRechazo.length == 1 && clienteserviceParam.listReglaRechazo[0].reglaDecision == 'RECHAZAR')">
              <p>EL CLIENTE</p>
              <h3>{{clienteserviceParam.datosCliente.cliente.nombreCompleto|accentMark: false }}</h3>
              <h4>FUE <strong class="rojo">RECHAZADO</strong></h4>
            </div>
            <br>
            <div *ngIf="clienteserviceParam.listReglaRechazo.length == 1 && clienteserviceParam.listReglaRechazo[0].reglaDecision == 'SIN DECISION'">
              <p>AL CLIENTE</p>
              <h3>{{clienteserviceParam.datosCliente.cliente.nombreCompleto|accentMark: false }}</h3>
              <h4>SE LE DEBE DAR <strong class="amarillo">SEGUIMIENTO</strong></h4>
            </div>
            <br>
            <div *ngIf="clienteserviceParam.listReglaRechazo.length > 0">
              <h1>REGLAS DE RECHAZO  <i (click)="isCollapseDebtor = !isCollapseDebtor"
                class="bi bi-arrow-down rejected-rules-collapse-icon">
              </i>
              </h1>
              <div *ngIf="!isCollapseDebtor">
                <h1 class="rejected-rules mt-4"
                    *ngFor="let regla of clienteserviceParam.listReglaRechazo; let i = index">
                  {{ i + 1 }}. {{ regla.reglaNombre }}
                  <hr *ngIf="clienteserviceParam.listReglaRechazo.length > 1">
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12" *ngIf="clienteserviceParam.flowType === 'CODEBTOR'">
      <div class="alert-card">
        <div class="row">
          <div class="col-md-2">
            <img *ngIf="clienteserviceParam.listReglaRechazoCodeudor.length === 0" class="centerImg" src="assets/icons/Botones Politicas Verde.png" height="50px" >
            <img *ngIf="clienteserviceParam.listReglaRechazoCodeudor.length > 1 ||(clienteserviceParam.listReglaRechazoCodeudor.length == 1 && clienteserviceParam.listReglaRechazoCodeudor[0].reglaDecision == 'RECHAZAR') " class="centerImg" src="assets/icons/Botones Politicas rojo.png" height="50px" >
            <img *ngIf="clienteserviceParam.listReglaRechazoCodeudor.length == 1 && clienteserviceParam.listReglaRechazoCodeudor[0].reglaDecision == 'SIN DECISION'" class="centerImg" src="assets/icons/Boton Amarillo.png" height="50px" >
          </div>
          <div class="col-md-10">
            <div *ngIf="clienteserviceParam.listReglaRechazoCodeudor.length === 0">
              <p>EL CODEUDOR</p>
              <h3>{{clienteserviceParam.datosCodeudor.cliente.nombreCompleto|accentMark: false }}</h3>
              <h4>FUE <strong class="verde">PREAPROBADO</strong></h4>
            </div>
            <div *ngIf="clienteserviceParam.listReglaRechazoCodeudor.length > 1 ||(clienteserviceParam.listReglaRechazoCodeudor.length == 1 && clienteserviceParam.listReglaRechazoCodeudor[0].reglaDecision == 'RECHAZAR')">
              <p>EL CODEUDOR</p>
              <h3>{{clienteserviceParam.datosCodeudor.cliente.nombreCompleto|accentMark: false }}</h3>
              <h4>FUE <strong class="rojo">RECHAZADO</strong></h4>
            </div>
            <div *ngIf="clienteserviceParam.listReglaRechazoCodeudor.length == 1 && clienteserviceParam.listReglaRechazoCodeudor[0].reglaDecision == 'SIN DECISION'">
              <p>AL CODEUDOR</p>
              <h3>{{clienteserviceParam.datosCodeudor.cliente.nombreCompleto|accentMark: false }}</h3>
              <h4>SE LE DEBE DAR <strong class="amarillo">SEGUIMIENTO</strong></h4> 
            </div>
            <br>
            <div *ngIf="clienteserviceParam.listReglaRechazoCodeudor.length > 0">
              <h1>REGLAS DE RECHAZO  <i (click)="isCollapseCoDebtor = !isCollapseCoDebtor"
                class="bi bi-arrow-down rejected-rules-collapse-icon">
              </i>
              </h1>
              <div *ngIf="!isCollapseCoDebtor">
                <h1 class="rejected-rules mt-4"
                    *ngFor="let regla of clienteserviceParam.listReglaRechazoCodeudor; let i = index">
                  {{ i + 1 }}. {{ regla.reglaNombre }}
                  <hr *ngIf="clienteserviceParam.listReglaRechazoCodeudor.length > 1">
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row"  *ngIf="showContent">
    <div class="col-md-6">
      <button class="btn round-button" (click)="goToConsolidacion()" 
        *ngIf="clienteserviceParam.tipoPrecalificacion !== 'tarjeta_credito'">
        Cambiar valores
      </button>
    </div>
    <div class="col-md-6">
      <button class="btn round-button" (click)="goToOferta()">Finalizar</button>
    </div>
  </div>
</div>
